import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import "./SkinAssessment.scss";
import SkinQuestionHeader from "./components/skinQuestionHeader/SkinQuestionHeader";
import LoadingOverlay from "react-loading-overlay";
import { getHnWAssessment, getHnWAssessmentDetail, resetSkinAssessmentAnswers, saveLastSavedAnswer, saveSkinAssessmentAnswer, updateAssessmentAnswer } from "../../../actions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { buildCurrentAnswer, buildQuestionPath, buildScoreMetaData, findQuestionLabelFromId, getNextLabelFromSavedAnswer, getNextQuestionLabel, getSectionId, getSkinType, isAnonymousFlow, isEntryQuestion, isLastQuestion } from "./components/utility";
import SkinAssessmentTemplate from './SkinAssessmentTemplate';
import { SkinAssessmentFooterContext } from "./SkinAssessmentFooterContext";
import { ASSESSMENT_FINAL_PAYLOAD_KEY, ASSESSMENT_IMAGE_URL, SKIN_ASM_CONSTANTS, SKIN_ASSESSMENT_QUESTION_TEMPLATE, SKIN_ASSESSMENT_QUESTION_TYPES, ASSESSMENT_IMAGE_UPLOAD_PROPS } from "../../../common/skinAssessmentConstant";
import UploadImagePopup from "./components/uploadImage/UploadImagePopup";
import { ASSESSMENT_STATUS } from "../../../common/commonConstant";
import { CommonAndroidWrapper } from "../../../common/challenge/commonAndroidWrapper/CommonAndroidWrapper";
import { getParamsString } from "../../../utill.func";
import { getLocalStorage } from "../../../services/promotion/utils.service";

const SkinAssessment = ({ routeTo, routeReplaceTo }) => {
    const hasAssessmentResumed = useRef(false);
    const imageRef = useRef(null);
    const androidWrapperRef = useRef(null);

    const { search } = useLocation();
    const urlParams = new URLSearchParams(search);
    const assessmentId = urlParams.get('assessment_id') || '';
    const startOver = urlParams.get('startOver') === 'true' || false;
    const anonymousCustId = urlParams.get('customer_id') ?? null;
    const anonymous = urlParams.get('isAnonymous') === 'true';

    const dispatch = useDispatch();
    const setFooterAction = useContext(SkinAssessmentFooterContext);
    const { assessmentDetail, assessmentQuestions, localAnswers, lastSavedAnswers } = useSelector((state) => state.assessment);

    const [loading, setLoading] = useState(false);
    const [isAnonymous, setIsAnonymous] = useState(anonymous);
    const [currentQuestionLabel, setCurrentQuestionLabel] = useState(null);
    const [nextQuestionLabel, setNextQuestionLabel] = useState(null);
    const [canGoNext, setCanGoNext] = useState(false);
    const [questionStack, setQuestionStack] = useState([]);
    const [answerId, setAnswerId] = useState('');
    const [isResumeSuccess, setIsResumeSuccess] = useState(false);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [pendingFinalSubmit, setPendingFinalSubmit] = useState(null);

    const sectionId = currentQuestionLabel && getSectionId(currentQuestionLabel);
    const showProgressHeader = !!sectionId && !!SKIN_ASSESSMENT_QUESTION_TEMPLATE[sectionId];
    const currentSection = assessmentQuestions?.hw_assessments?.[sectionId];
    const currentTemplate = currentSection?.template;
    const shouldSkipResume = startOver || isAnonymous || assessmentDetail?.assessments_status === ASSESSMENT_STATUS.done;
    let currentQuestion = null;

    if (sectionId === SKIN_ASM_CONSTANTS.M1) {
        if (currentQuestionLabel === SKIN_ASM_CONSTANTS.M1) {
            currentQuestion = currentSection.entry;
        } else if (currentQuestionLabel === SKIN_ASM_CONSTANTS.M1E) {
            currentQuestion = currentSection.notSure;
        } else {
            const match = currentQuestionLabel.match(/^M1\.([A-Z])\./);
            const branchKey = match?.[1];
            currentQuestion = currentSection.branches?.[branchKey]?.find(q => q.question_label === currentQuestionLabel);
        }
    } else {
        currentQuestion = currentSection?.questions?.find(ques => ques.question_label === currentQuestionLabel);
    }
    const savedAnswerIds = localAnswers?.[currentQuestion?.question_label]?.answer_ids || [];

    useEffect(() => {
        const didMount = async () => {
            const imageUrl = await getLocalStorage(ASSESSMENT_IMAGE_URL);
            console.log("ASSESSMENT IMAGE URL--------->", imageUrl);
            const isValidImageUrl = imageUrl && imageUrl !== null && imageUrl !== undefined && imageUrl !== '';
            
            if (isValidImageUrl) {
                localStorage.removeItem(ASSESSMENT_IMAGE_URL);
                await handleFinalSubmitWithImage(imageUrl);
            } else {
                await fetchAssessmentInfo();
            }
        };
        didMount();
    }, []);

    useEffect(() => {
        if (!currentQuestion) return;

        if (currentQuestion.question_type !== SKIN_ASSESSMENT_QUESTION_TYPES.bar) return;

        const alreadyAnswered = localAnswers?.[currentQuestion.question_label];
        if (alreadyAnswered?.answer_ids?.length) {
            setCanGoNext(true);
            return;
        }

        const firstOption = currentQuestion?.question_value?.[0];
        if (!firstOption) return;

        dispatch(saveSkinAssessmentAnswer({ question_label: currentQuestion?.question_label, question_id: currentQuestion?._id, answer_ids: [firstOption._id] }));
        setCanGoNext(true);
    }, [currentQuestion?.question_label]);

    useEffect(() => {
        if (shouldSkipResume) {
            dispatch(resetSkinAssessmentAnswers());
            localStorage.removeItem(ASSESSMENT_IMAGE_UPLOAD_PROPS);
            hasAssessmentResumed.current = true;
        }
    }, [startOver, isAnonymous, assessmentDetail]);

    useEffect(() => {
        if (!assessmentQuestions || !isResumeSuccess) return;

        const answerId = assessmentQuestions && assessmentQuestions.answer_id;
        setAnswerId(answerId);

        if (!Object.keys(localAnswers || {}).length) {

            if (anonymous) {
                setCurrentQuestionLabel(SKIN_ASM_CONSTANTS.GENDER);
            } else {
                setCurrentQuestionLabel(SKIN_ASM_CONSTANTS.M1);
            }
        }
    }, [assessmentQuestions, isResumeSuccess]);

    const fetchAssessmentInfo = async () => {
        try {
            setLoading(true);
            if (!isAnonymous && !assessmentDetail?.answers?.length) {
                await dispatch(getHnWAssessmentDetail(assessmentId));
            }
            await dispatch(getHnWAssessment(assessmentId, { customer_id: anonymousCustId }));
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };

    useEffect(() => {

        if (shouldSkipResume) {
            setIsResumeSuccess(true);
            return;
        }

        if (startOver || isAnonymous) {
            setIsResumeSuccess(true);
            return;
        }

        if (!assessmentDetail || !assessmentQuestions?.hw_assessments) return;

        if (!assessmentDetail?.answers?.length || assessmentDetail?.assessments_status === ASSESSMENT_STATUS.done) {
            setIsResumeSuccess(true);
            return;
        }

        if (!assessmentQuestions?.hw_assessments) return;

        const resumeAnswers = {};

        assessmentDetail.answers.forEach(ans => {
            const label = findQuestionLabelFromId(
                ans.question_id,
                assessmentQuestions?.hw_assessments
            );

            if (!label) return;

            resumeAnswers[label] = {
                question_id: ans.question_id,
                answer_ids: ans.answer,
            };
        });

        if (Object.keys(resumeAnswers).length) {
            Object.entries(resumeAnswers).forEach(([label, data]) => {
                dispatch(saveSkinAssessmentAnswer({ question_label: label, question_id: data?.question_id, answer_ids: data.answer_ids, }));
                dispatch(saveLastSavedAnswer({ saved_question_id: data?.question_id, saved_question_label: label, saved_answer_ids: data?.answer_ids, }));
            })

        }
        setIsResumeSuccess(true);

    }, [assessmentDetail, assessmentQuestions, shouldSkipResume]);

    useEffect(() => {
        if (startOver || isAnonymous) return;
        if (!isResumeSuccess) return;
        if (hasAssessmentResumed.current) return;
        if (!assessmentQuestions || !Object.keys(lastSavedAnswers || {}).length) return;

        const path = buildQuestionPath({
            startLabel: isAnonymous ? SKIN_ASM_CONSTANTS.GENDER : SKIN_ASM_CONSTANTS.M1,
            localAnswers: lastSavedAnswers,
            questionsBySection: assessmentQuestions.hw_assessments,
        });

        if (!path.length) return;
        hasAssessmentResumed.current = true;

        setQuestionStack(path.slice(0, -1));
        setCurrentQuestionLabel(path[path.length - 1]);

        setCanGoNext(false);
        setNextQuestionLabel(null);
    }, [isResumeSuccess, assessmentQuestions]);

    useEffect(() => {
        const hasAnswer = localAnswers?.[currentQuestionLabel]?.answer_ids?.length > 0;
        setCanGoNext(!!hasAnswer);
    }, [currentQuestionLabel, localAnswers]);

    const handleFinalSubmitWithImage = async (profileImageUrl) => {
        setLoading(true);
        const payload =
            pendingFinalSubmit ||
            JSON.parse(
                sessionStorage.getItem(ASSESSMENT_FINAL_PAYLOAD_KEY)
            );

        if (!payload) return;

        await dispatch(
            updateAssessmentAnswer(
                payload.assessmentId,
                payload.currentAnswer,
                payload.answerId,
                ASSESSMENT_STATUS.done,
                {
                    ...payload.meta,
                    profileImageUrl,
                }
            )
        );

        sessionStorage.removeItem(ASSESSMENT_FINAL_PAYLOAD_KEY);
        setShowImagePopup(false);
        const params = {
            assessment_id: payload.assessmentId,
            answer_id: payload.answerId,
            customer_id: payload.meta?.customer_id
        }

        routeReplaceTo('pathHnWSkinAssessment', `?assessment_id=${payload?.assessmentId}`);
        routeTo('pathSkinAssessmentResult', `?${getParamsString(params)}`);
        setLoading(false);
    };



    const handleAnswersSelect = ({ canGoNext, nextLabel, question_id, question_label, answer_ids }) => {

        dispatch(saveSkinAssessmentAnswer({ question_id, question_label, answer_ids }));

        setCanGoNext(canGoNext);
        setNextQuestionLabel(nextLabel);
    }

    const handleNext = async () => {
        const saved = localAnswers?.[currentQuestionLabel];
        if (!saved) return;

        let savedApiAnswerIds = [];

        if (lastSavedAnswers?.[currentQuestionLabel]?.saved_answer_ids?.length) {
            savedApiAnswerIds =
                lastSavedAnswers[currentQuestionLabel].saved_answer_ids;
        } else if (assessmentDetail?.answers?.length) {
            const apiAnswer = assessmentDetail.answers.find(
                a => a.question_id === currentQuestion?._id
            );
            savedApiAnswerIds = apiAnswer?.answers || [];
        }

        const localAnswerIds = saved.answer_ids || [];
        const hasSavedAnswer = savedApiAnswerIds.length > 0;

        const hasAnswerChanged =
            JSON.stringify(localAnswerIds) !==
            JSON.stringify(savedApiAnswerIds);

        const isAutoForward =
            hasSavedAnswer &&
            !hasAnswerChanged &&
            !nextQuestionLabel;

        const isAnonymousPreselected = isAnonymousFlow(currentQuestionLabel) && !hasSavedAnswer && localAnswerIds?.length > 0 && !nextQuestionLabel;

        if (isAnonymousFlow(currentQuestionLabel)) {
            let resolvedNextLabel = nextQuestionLabel;

            if (!resolvedNextLabel && isAnonymousPreselected) {
                resolvedNextLabel =
                    currentQuestionLabel === SKIN_ASM_CONSTANTS.GENDER
                        ? SKIN_ASM_CONSTANTS.AGE
                        : currentQuestionLabel === SKIN_ASM_CONSTANTS.AGE
                            ? SKIN_ASM_CONSTANTS.M1
                            : null;
            }

            if (!resolvedNextLabel) return;

            setQuestionStack(prev => [...prev, currentQuestionLabel]);
            setCurrentQuestionLabel(resolvedNextLabel);
            setNextQuestionLabel(null);
            return;
        }

        if (isAutoForward) {
            let nextLabel = null;

            if (isEntryQuestion(currentQuestionLabel)) {
                nextLabel = nextQuestionLabel || getNextLabelFromSavedAnswer(currentQuestion, savedApiAnswerIds);
            } else {
                nextLabel = getNextQuestionLabel({
                    currentQuestionLabel,
                    nextQuestionLabel,
                    questionsBySection: assessmentQuestions.hw_assessments,
                });
            }

            if (!nextLabel) return;

            setQuestionStack(prev => [...prev, currentQuestionLabel]);
            setCurrentQuestionLabel(nextLabel);
            setNextQuestionLabel(null);
            return;
        }

        const isFinalQuestion = isLastQuestion({
            currentQuestionLabel,
            nextQuestionLabel,
            questionsBySection: assessmentQuestions.hw_assessments,
        });

        const skinType = getSkinType({
            localAnswers,
            questionsBySection: assessmentQuestions?.hw_assessments,
        });

        const scoreMetaData = buildScoreMetaData({
            question: currentQuestion,
            answerIds: localAnswerIds,
            skinType,
            previousAnswerIds: savedApiAnswerIds,
        });

        const currentAnswerObj = buildCurrentAnswer(
            currentQuestion,
            localAnswerIds
        );

        const currentAnswer = [currentAnswerObj];

        if (!isFinalQuestion) {
            await submitAndMoveNext({
                currentAnswerObj,
                skinType,
                scoreMetaData,
            });
            return;
        }

        if (!isFinalQuestion && (!hasSavedAnswer || hasAnswerChanged)) {
            await dispatch(
                updateAssessmentAnswer(
                    assessmentId,
                    currentAnswer,
                    answerId,
                    ASSESSMENT_STATUS.pending,
                    {
                        assessment_label: assessmentQuestions?.assessment_label,
                        skinType,
                        scoreMetadata: scoreMetaData,
                        profileImageUrl: '',
                        customer_id: anonymousCustId,
                    }
                )
            );
        }

        const finalPayload = {
            assessmentId,
            currentAnswer,
            answerId,
            status: ASSESSMENT_STATUS.done,
            meta: {
                assessment_label: assessmentQuestions?.assessment_label,
                skinType,
                scoreMetadata: scoreMetaData,
                profileImageUrl: '',
                customer_id: anonymousCustId,
            },
        };

        if (isAnonymous) {
            await dispatch(updateAssessmentAnswer(
                finalPayload?.assessmentId,
                finalPayload?.currentAnswer,
                finalPayload?.answerId,
                ASSESSMENT_STATUS.done,
                finalPayload?.meta
            ));

            const params = {
                assessment_id: finalPayload?.assessmentId,
                answer_id: finalPayload?.answerId,
                customer_id: finalPayload?.meta?.customer_id,
                isAnonymous: isAnonymous
            };

            routeReplaceTo('pathHnWSkinAssessment', `?assessment_id=${finalPayload?.assessmentId}`);
            routeTo('pathSkinAssessmentResult', `?${getParamsString(params)}`);
            return;
        }

        setPendingFinalSubmit(finalPayload);
        sessionStorage.setItem(
            ASSESSMENT_FINAL_PAYLOAD_KEY,
            JSON.stringify(finalPayload)
        );

        setShowImagePopup(true);
    };

    const submitAndMoveNext = async ({
        currentAnswerObj,
        skinType,
        scoreMetaData,
        profileImageUrl = '',
        status = ASSESSMENT_STATUS.pending
    }) => {
        try {
            setLoading(true);
            const res = await dispatch(updateAssessmentAnswer(assessmentId, [currentAnswerObj], answerId, status,
                {
                    assessment_label: assessmentQuestions?.assessment_label,
                    skinType: skinType,
                    scoreMetadata: scoreMetaData,
                    profileImageUrl,
                    customer_id: anonymousCustId
                }
            )).then(res => {
                if (res?.success && res?.answerId) {
                    dispatch(saveLastSavedAnswer({
                        saved_question_id: currentQuestion?._id,
                        saved_question_label: currentQuestionLabel,
                        saved_answer_ids: currentAnswerObj.answer,
                    }))
                    setAnswerId(res?.answerId);

                    if (isEntryQuestion(currentQuestionLabel)) {
                        const savedAnswerIds = localAnswers?.[currentQuestionLabel]?.answer_ids || [];

                        const nextQueLabel = nextQuestionLabel || getNextLabelFromSavedAnswer(currentQuestion, savedAnswerIds);

                        if (!nextQueLabel) return;

                        setQuestionStack(prev => [...prev, currentQuestionLabel]);
                        setCurrentQuestionLabel(nextQueLabel);
                        setNextQuestionLabel(null);
                        return;
                    }

                    const nextLabel = getNextQuestionLabel({
                        currentQuestionLabel,
                        nextQuestionLabel,
                        questionsBySection: assessmentQuestions.hw_assessments
                    });
                    if (!nextLabel) return;

                    setQuestionStack(prev => [...prev, currentQuestionLabel]);
                    setCurrentQuestionLabel(nextLabel);
                    setNextQuestionLabel(null);
                }
            });
        } catch (err) {
        } finally {
            setLoading(false);
        }
    }

    const continueWithoutImage = async () => {
        setLoading(true);
        const { currentAnswer, meta } = pendingFinalSubmit;

        await dispatch(updateAssessmentAnswer(
            assessmentId,
            currentAnswer,
            answerId,
            ASSESSMENT_STATUS.done,
            {
                assessment_label: assessmentQuestions?.assessment_label,
                skinType: meta.skinType,
                scoreMetadata: meta.scoreMetadata,
                profileImageUrl: '',
                customer_id: anonymousCustId
            }
        ));
        const params = {
            assessment_id: assessmentId,
            answer_id: answerId,
            customer_id: anonymousCustId,
            isAnonymous: isAnonymous
        }

        setShowImagePopup(false);
        setLoading(false);
        routeReplaceTo('pathHnWSkinAssessment', `?assessment_id=${assessmentId}`);
        routeTo('pathSkinAssessmentResult', `?${getParamsString(params)}`);
    };

    const handleBack = () => {
        setQuestionStack(prev => {
            if (prev.length > 0) {
                const newStack = [...prev];
                const prevLabel = newStack.pop();

                setCurrentQuestionLabel(prevLabel);
                setNextQuestionLabel(null);

                return newStack;
            }
            routeTo('pathHnWSkinAssessment', `?assessment_id=${urlParams.get('assessment_id')}`);
            return prev;
        });
    };

    useEffect(() => {
        if (!setFooterAction) return;

        setFooterAction({
            buttonActive: canGoNext,
            handleSubmit: handleNext,
            handleBack: handleBack,
        });

    }, [canGoNext, handleNext]);

    const AlertError = (message) => {
        Swal.fire({
            title: "",
            text: message,
            confirmButtonText: "ตกลง"
        });
    };

    const handleAssessmentImageConfirm = async (imageUrl) => {
        await handleFinalSubmitWithImage(imageUrl)
    };

    const handleAssessmentImageCancel = () => {
        setShowImagePopup(true);
    }

    return (
        <div>
            {loading ? (<LoadingOverlay
                text="Loading"
                spinner
                active={loading}
                styles={{ wrapper: { width: '100%', height: '100%', position: 'fixed', top: 0, left: 0, zIndex: 10 } }}
            >
                <div />
            </LoadingOverlay>) : null}
            <div
                className={`skin-assessment-container ${currentTemplate?.bgClassName ?? 'anonymous-gradient'}`}
            >
                {showProgressHeader &&
                    <SkinQuestionHeader currentSectionId={`${sectionId}`} currentQuestionLabel={currentQuestionLabel} isAnonymousType={isAnonymous} />}
                <div
                    className="assessment-body"
                >
                    <SkinAssessmentTemplate question={currentQuestion} sectionId={sectionId} onAnswerSelect={handleAnswersSelect} savedAnswerIds={savedAnswerIds} />
                </div>
            </div>
            <CommonAndroidWrapper
                ref={androidWrapperRef}
                imageRef={imageRef}
                componentInstance={SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE}
                onAssessmentImageConfirm={handleAssessmentImageConfirm}
                onAssessmentImageCancel={handleAssessmentImageCancel}
                assessmentLabel={assessmentQuestions?.assessment_label}
                eventId={null}
                partyId={null}
                aboId={null}
                userId={null}
                redirectionEventIdQuery={null}
                photos={{}}
                setPhotos={() => { }}
                setPhotosLoading={() => { }}
            />
            {showImagePopup && <UploadImagePopup title='เก็บภาพใบหน้า' skipUpload={continueWithoutImage} onUploadClick={() => { androidWrapperRef.current.handleImageUpload('ASSESSMENT_IMAGE') }} />}
        </div>
    )
}

export default SkinAssessment;